import styled, { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`
  @font-face {
  font-family: 'PT Serif';
  font-style: italic;
  font-weight: 400;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/ptserif/v12/EJRTQgYoZZY2vCFuvAFTzro.ttf) format('truetype');
}
@font-face {
  font-family: Roboto;
  font-style: normal;
  font-weight: 100;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/roboto/v20/KFOkCnqEu92Fr1MmgWxP.ttf) format('truetype');
}
@font-face {
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmSU5vAw.ttf) format('truetype');
}
@font-face {
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/roboto/v20/KFOmCnqEu92Fr1Me5Q.ttf) format('truetype');
}
@font-face {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmEU9vAw.ttf) format('truetype');
}
@font-face {
  font-family: Roboto;
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmWUlvAw.ttf) format('truetype');
}
@font-face {
  font-family: 'Roboto Condensed';
  font-style: normal;
  font-weight: 300;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/robotocondensed/v19/ieVi2ZhZI2eCN5jzbjEETS9weq8-33mZKCM.ttf) format('truetype');
}
@font-face {
  font-family: 'Roboto Condensed';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/robotocondensed/v19/ieVl2ZhZI2eCN5jzbjEETS9weq8-59U.ttf) format('truetype');
}
@font-face {
  font-family: 'Roboto Condensed';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/robotocondensed/v19/ieVi2ZhZI2eCN5jzbjEETS9weq8-32meKCM.ttf) format('truetype');
}
@font-face {
  font-family: 'Roboto Mono';
  font-style: normal;
  font-weight: 200;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/robotomono/v13/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_XvqPQw.ttf) format('truetype');
}
@font-face {
  font-family: 'Roboto Mono';
  font-style: normal;
  font-weight: 300;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/robotomono/v13/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_gPqPQw.ttf) format('truetype');
}
@font-face {
  font-family: 'Roboto Mono';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/robotomono/v13/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_3vqPQw.ttf) format('truetype');
}
@font-face {
  font-family: 'Roboto Mono';
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/robotomono/v13/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_7PqPQw.ttf) format('truetype');
}
@font-face {
  font-family: 'Roboto Mono';
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/robotomono/v13/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_AP2PQw.ttf) format('truetype');
}
@font-face {
  font-family: 'Roboto Mono';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/robotomono/v13/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_Of2PQw.ttf) format('truetype');
}

html {
  box-sizing: border-box;
}

*,
::after,
::before {
  box-sizing: inherit;
}
`

export const Styler = styled.div`
  font-family: Roboto, sans-serif, arial;

  .button,
  .hs-button {
    position: relative;
    display: inline-block;
    margin-bottom: 20px;
    padding: 4px 19px 3px 19px;
    min-width: 130px;
    border: 0;
    border-radius: 100px;
    background-color: #56a0d3;
    cursor: pointer;
    font-family: Roboto, sans-serif, arial;
    font-size: 12px;
    color: #fff;
    font-weight: 500;
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;
    line-height: 30px;
    outline: 0;
    -webkit-transition: padding 0.2s;
    -moz-transition: padding 0.2s;
    transition: padding 0.2s;
  }
  .button:after,
  .hs-button:after {
    content: '';
    display: inline-block;
    vertical-align: middle;
    margin-top: -2px;
    background: transparent url(/img/arrow_yellow.png) no-repeat right top;
    background-size: auto 11px;
    width: 0;
    height: 11px;
    -webkit-transition: width 0.2s;
    -moz-transition: width 0.2s;
    transition: width 0.2s;
  }
  .button-wrapper .button,
  .button-wrapper .hs-button {
    margin-left: 6px;
    margin-right: 6px;
  }
  .button-wrapper .button:last-child,
  .button-wrapper .hs-button:last-child {
    margin-bottom: 0;
  }
  @media screen and (max-width: 480px) {
    .button-wrapper .button,
    .button-wrapper .hs-button {
      width: 100%;
      margin-left: 0;
      margin-right: 0;
    }
  }
  .button-image {
    display: inline-block;
    vertical-align: middle;
    margin-right: 8px;
  }
  .button--dark {
    background-color: #303030;
  }
  .button:hover,
  .hs-button:hover {
    color: #fff;
    padding: 4px 8px 3px 8px;
  }
  .button:hover:after,
  .hs-button:hover:after {
    width: 22px;
  }
  .button--disabled {
    padding: 3px 18px 2px 18px !important;
    background: 0 0;
    color: #303030 !important;
    box-shadow: inset 0 0 0 1px #303030;
    cursor: default;
    pointer-events: none;
  }
  .button--disabled:after {
    content: none;
  }
  .button--active {
    padding: 3px 18px 2px 18px !important;
    background: 0 0;
    color: #303030 !important;
    font-weight: 700;
    box-shadow: inset 0 0 0 3px #303030;
    -webkit-transition: background 0.2s;
    -moz-transition: background 0.2s;
    transition: background 0.2s;
  }
  .button--active:after {
    content: none;
  }
  .button--active:hover {
    background: #f5f5f5;
  }
  .button--large {
    padding: 8px 42px 7px 42px;
  }
  .button--large:hover {
    padding: 8px 31px 7px 31px;
  }
  .button--large.button--disabled {
    padding: 8px 42px 7px 42px !important;
  }
  .button--large.button--active {
    padding: 8px 42px 7px 42px !important;
  }
  .button--huge {
    padding: 13px 42px 12px 42px;
  }
  .button--huge:hover {
    padding: 13px 31px 12px 31px;
  }
  .button--huge.button--disabled {
    padding: 13px 42px 12px 42px !important;
  }
  .button--wide,
  .hs-button {
    width: 100%;
  }
  .button--fancy {
    letter-spacing: 2px;
  }
  @media screen and (max-width: 480px) {
    .button--mobilewide {
      width: 100%;
    }
  }
  .grid-full-height {
    height: 100%;
  }
  .grid-row {
    display: block;
  }
  .grid-row::after {
    clear: both;
    content: '';
    display: block;
  }
  .grid-outer-container {
    max-width: 1140px;
    margin-left: auto;
    margin-right: auto;
  }
  .grid-outer-container::after {
    clear: both;
    content: '';
    display: block;
  }
  .grid-fill-parent {
    width: 100%;
  }
  .grid-text-left {
    text-align: left;
  }
  .grid-text-center {
    text-align: center;
  }
  .grid-text-right {
    text-align: right;
  }
  .grid-hidden {
    display: none;
  }
  .grid-visible {
    display: block;
  }
  .grid-span1-nogap {
    float: left;
    display: block;
    width: 8.33333%;
    margin-right: 0;
  }
  .grid-span2-nogap {
    float: left;
    display: block;
    width: 16.66667%;
    margin-right: 0;
  }
  .grid-span3-nogap {
    float: left;
    display: block;
    width: 25%;
    margin-right: 0;
  }
  .grid-span4-nogap {
    float: left;
    display: block;
    width: 33.33333%;
    margin-right: 0;
  }
  .grid-span5-nogap {
    float: left;
    display: block;
    width: 41.66667%;
    margin-right: 0;
  }
  .grid-span6-nogap {
    float: left;
    display: block;
    width: 50%;
    margin-right: 0;
  }
  .grid-span7-nogap {
    float: left;
    display: block;
    width: 58.33333%;
    margin-right: 0;
  }
  .grid-span8-nogap {
    float: left;
    display: block;
    width: 66.66667%;
    margin-right: 0;
  }
  .grid-span9-nogap {
    float: left;
    display: block;
    width: 75%;
    margin-right: 0;
  }
  .grid-span10-nogap {
    float: left;
    display: block;
    width: 83.33333%;
    margin-right: 0;
  }
  .grid-span11-nogap {
    float: left;
    display: block;
    width: 91.66667%;
    margin-right: 0;
  }
  .grid-span12-nogap {
    float: left;
    display: block;
    width: 100%;
    margin-right: 0;
  }
  .grid-shift1-nogap {
    margin-left: 8.33333%;
  }
  .grid-shift2-nogap {
    margin-left: 16.66667%;
  }
  .grid-shift3-nogap {
    margin-left: 25%;
  }
  .grid-shift4-nogap {
    margin-left: 33.33333%;
  }
  .grid-shift5-nogap {
    margin-left: 41.66667%;
  }
  .grid-shift6-nogap {
    margin-left: 50%;
  }
  .grid-shift7-nogap {
    margin-left: 58.33333%;
  }
  .grid-shift8-nogap {
    margin-left: 66.66667%;
  }
  .grid-shift9-nogap {
    margin-left: 75%;
  }
  .grid-shift10-nogap {
    margin-left: 83.33333%;
  }
  .grid-shift11-nogap {
    margin-left: 91.66667%;
  }
  .grid-shift12-nogap {
    margin-left: 100%;
  }
  .grid-span1 {
    float: left;
    display: block;
    margin-right: 2.35765%;
    width: 6.17215%;
  }
  .grid-span1:last-child {
    margin-right: 0;
  }
  .grid-span2 {
    float: left;
    display: block;
    margin-right: 2.35765%;
    width: 14.70196%;
  }
  .grid-span2:last-child {
    margin-right: 0;
  }
  .grid-span3 {
    float: left;
    display: block;
    margin-right: 2.35765%;
    width: 23.23176%;
  }
  .grid-span3:last-child {
    margin-right: 0;
  }
  .grid-span4 {
    float: left;
    display: block;
    margin-right: 2.35765%;
    width: 31.76157%;
  }
  .grid-span4:last-child {
    margin-right: 0;
  }
  .grid-span5 {
    float: left;
    display: block;
    margin-right: 2.35765%;
    width: 40.29137%;
  }
  .grid-span5:last-child {
    margin-right: 0;
  }
  .grid-span6 {
    float: left;
    display: block;
    margin-right: 2.35765%;
    width: 48.82117%;
  }
  .grid-span6:last-child {
    margin-right: 0;
  }
  .grid-span7 {
    float: left;
    display: block;
    margin-right: 2.35765%;
    width: 57.35098%;
  }
  .grid-span7:last-child {
    margin-right: 0;
  }
  .grid-span8 {
    float: left;
    display: block;
    margin-right: 2.35765%;
    width: 65.88078%;
  }
  .grid-span8:last-child {
    margin-right: 0;
  }
  .grid-span9 {
    float: left;
    display: block;
    margin-right: 2.35765%;
    width: 74.41059%;
  }
  .grid-span9:last-child {
    margin-right: 0;
  }
  .grid-span10 {
    float: left;
    display: block;
    margin-right: 2.35765%;
    width: 82.94039%;
  }
  .grid-span10:last-child {
    margin-right: 0;
  }
  .grid-span11 {
    float: left;
    display: block;
    margin-right: 2.35765%;
    width: 91.4702%;
  }
  .grid-span11:last-child {
    margin-right: 0;
  }
  .grid-span12 {
    float: left;
    display: block;
    margin-right: 2.35765%;
    width: 100%;
  }
  .grid-span12:last-child {
    margin-right: 0;
  }
  .grid-shift0 {
    margin-left: 0;
  }
  .grid-shift1 {
    margin-left: 8.5298%;
  }
  .grid-shift2 {
    margin-left: 17.05961%;
  }
  .grid-shift3 {
    margin-left: 25.58941%;
  }
  .grid-shift4 {
    margin-left: 34.11922%;
  }
  .grid-shift5 {
    margin-left: 42.64902%;
  }
  .grid-shift6 {
    margin-left: 51.17883%;
  }
  .grid-shift7 {
    margin-left: 59.70863%;
  }
  .grid-shift8 {
    margin-left: 68.23843%;
  }
  .grid-shift9 {
    margin-left: 76.76824%;
  }
  .grid-shift10 {
    margin-left: 85.29804%;
  }
  .grid-shift11 {
    margin-left: 93.82785%;
  }
  .grid-shift-negative1 {
    margin-left: -8.5298%;
  }
  .grid-shift-negative2 {
    margin-left: -17.05961%;
  }
  .grid-shift-negative3 {
    margin-left: -25.58941%;
  }
  .grid-shift-negative4 {
    margin-left: -34.11922%;
  }
  .grid-shift-negative5 {
    margin-left: -42.64902%;
  }
  .grid-shift-negative6 {
    margin-left: -51.17883%;
  }
  .grid-shift-negative7 {
    margin-left: -59.70863%;
  }
  .grid-shift-negative8 {
    margin-left: -68.23843%;
  }
  .grid-shift-negative9 {
    margin-left: -76.76824%;
  }
  .grid-shift-negative10 {
    margin-left: -85.29804%;
  }
  .grid-shift-negative11 {
    margin-left: -93.82785%;
  }
  .grid-shift-negative12 {
    margin-left: -102.35765%;
  }
  .grid-omega {
    margin-right: 0;
  }
  .grid-omega1:nth-child(1n) {
    margin-right: 0;
  }
  .grid-omega1:nth-child(1n + 1) {
    clear: left;
  }
  .grid-omega2:nth-child(2n) {
    margin-right: 0;
  }
  .grid-omega2:nth-child(2n + 1) {
    clear: left;
  }
  .grid-omega3:nth-child(3n) {
    margin-right: 0;
  }
  .grid-omega3:nth-child(3n + 1) {
    clear: left;
  }
  .grid-omega4:nth-child(4n) {
    margin-right: 0;
  }
  .grid-omega4:nth-child(4n + 1) {
    clear: left;
  }
  .grid-omega5:nth-child(5n) {
    margin-right: 0;
  }
  .grid-omega5:nth-child(5n + 1) {
    clear: left;
  }
  .grid-omega6:nth-child(6n) {
    margin-right: 0;
  }
  .grid-omega6:nth-child(6n + 1) {
    clear: left;
  }
  .grid-omega7:nth-child(7n) {
    margin-right: 0;
  }
  .grid-omega7:nth-child(7n + 1) {
    clear: left;
  }
  .grid-omega8:nth-child(8n) {
    margin-right: 0;
  }
  .grid-omega8:nth-child(8n + 1) {
    clear: left;
  }
  .grid-omega9:nth-child(9n) {
    margin-right: 0;
  }
  .grid-omega9:nth-child(9n + 1) {
    clear: left;
  }
  .grid-omega10:nth-child(10n) {
    margin-right: 0;
  }
  .grid-omega10:nth-child(10n + 1) {
    clear: left;
  }
  .grid-omega11:nth-child(11n) {
    margin-right: 0;
  }
  .grid-omega11:nth-child(11n + 1) {
    clear: left;
  }
  .grid-omega12:nth-child(12n) {
    margin-right: 0;
  }
  .grid-omega12:nth-child(12n + 1) {
    clear: left;
  }
  .grid-gap0-below {
    margin-bottom: 0;
  }
  .grid-gap1-below {
    margin-bottom: 10px;
  }
  .grid-gap2-below {
    margin-bottom: 20px;
  }
  .grid-gap3-below {
    margin-bottom: 30px;
  }
  .grid-gap4-below {
    margin-bottom: 40px;
  }
  .grid-gap5-below {
    margin-bottom: 50px;
  }
  .grid-gap6-below {
    margin-bottom: 60px;
  }
  .grid-gap7-below {
    margin-bottom: 70px;
  }
  .grid-gap8-below {
    margin-bottom: 80px;
  }
  .grid-gap9-below {
    margin-bottom: 90px;
  }
  .grid-gap10-below {
    margin-bottom: 100px;
  }
  .grid-gap0-above {
    margin-top: 0;
  }
  .grid-gap1-above {
    margin-top: 10px;
  }
  .grid-gap2-above {
    margin-top: 20px;
  }
  .grid-gap3-above {
    margin-top: 30px;
  }
  .grid-gap4-above {
    margin-top: 40px;
  }
  .grid-gap5-above {
    margin-top: 50px;
  }
  .grid-gap6-above {
    margin-top: 60px;
  }
  .grid-gap7-above {
    margin-top: 70px;
  }
  .grid-gap8-above {
    margin-top: 80px;
  }
  .grid-gap9-above {
    margin-top: 90px;
  }
  .grid-gap10-above {
    margin-top: 100px;
  }
  @media screen and (max-width: 1180px) {
    .grid-desktop-row {
      display: block;
    }
    .grid-desktop-row::after {
      clear: both;
      content: '';
      display: block;
    }
    .grid-desktop-outer-container {
      max-width: 1140px;
      margin-left: auto;
      margin-right: auto;
    }
    .grid-desktop-outer-container::after {
      clear: both;
      content: '';
      display: block;
    }
    .grid-desktop-fill-parent {
      width: 100%;
    }
    .grid-desktop-text-left {
      text-align: left;
    }
    .grid-desktop-text-center {
      text-align: center;
    }
    .grid-desktop-text-right {
      text-align: right;
    }
    .grid-desktop-hidden {
      display: none;
    }
    .grid-desktop-visible {
      display: block;
    }
    .grid-desktop-span1-nogap {
      float: left;
      display: block;
      width: 8.33333%;
      margin-right: 0;
    }
    .grid-desktop-span2-nogap {
      float: left;
      display: block;
      width: 16.66667%;
      margin-right: 0;
    }
    .grid-desktop-span3-nogap {
      float: left;
      display: block;
      width: 25%;
      margin-right: 0;
    }
    .grid-desktop-span4-nogap {
      float: left;
      display: block;
      width: 33.33333%;
      margin-right: 0;
    }
    .grid-desktop-span5-nogap {
      float: left;
      display: block;
      width: 41.66667%;
      margin-right: 0;
    }
    .grid-desktop-span6-nogap {
      float: left;
      display: block;
      width: 50%;
      margin-right: 0;
    }
    .grid-desktop-span7-nogap {
      float: left;
      display: block;
      width: 58.33333%;
      margin-right: 0;
    }
    .grid-desktop-span8-nogap {
      float: left;
      display: block;
      width: 66.66667%;
      margin-right: 0;
    }
    .grid-desktop-span9-nogap {
      float: left;
      display: block;
      width: 75%;
      margin-right: 0;
    }
    .grid-desktop-span10-nogap {
      float: left;
      display: block;
      width: 83.33333%;
      margin-right: 0;
    }
    .grid-desktop-span11-nogap {
      float: left;
      display: block;
      width: 91.66667%;
      margin-right: 0;
    }
    .grid-desktop-span12-nogap {
      float: left;
      display: block;
      width: 100%;
      margin-right: 0;
    }
    .grid-desktop-shift1-nogap {
      margin-left: 8.33333%;
    }
    .grid-desktop-shift2-nogap {
      margin-left: 16.66667%;
    }
    .grid-desktop-shift3-nogap {
      margin-left: 25%;
    }
    .grid-desktop-shift4-nogap {
      margin-left: 33.33333%;
    }
    .grid-desktop-shift5-nogap {
      margin-left: 41.66667%;
    }
    .grid-desktop-shift6-nogap {
      margin-left: 50%;
    }
    .grid-desktop-shift7-nogap {
      margin-left: 58.33333%;
    }
    .grid-desktop-shift8-nogap {
      margin-left: 66.66667%;
    }
    .grid-desktop-shift9-nogap {
      margin-left: 75%;
    }
    .grid-desktop-shift10-nogap {
      margin-left: 83.33333%;
    }
    .grid-desktop-shift11-nogap {
      margin-left: 91.66667%;
    }
    .grid-desktop-shift12-nogap {
      margin-left: 100%;
    }
    .grid-desktop-span1 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 6.17215%;
    }
    .grid-desktop-span1:last-child {
      margin-right: 0;
    }
    .grid-desktop-span2 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 14.70196%;
    }
    .grid-desktop-span2:last-child {
      margin-right: 0;
    }
    .grid-desktop-span3 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 23.23176%;
    }
    .grid-desktop-span3:last-child {
      margin-right: 0;
    }
    .grid-desktop-span4 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 31.76157%;
    }
    .grid-desktop-span4:last-child {
      margin-right: 0;
    }
    .grid-desktop-span5 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 40.29137%;
    }
    .grid-desktop-span5:last-child {
      margin-right: 0;
    }
    .grid-desktop-span6 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 48.82117%;
    }
    .grid-desktop-span6:last-child {
      margin-right: 0;
    }
    .grid-desktop-span7 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 57.35098%;
    }
    .grid-desktop-span7:last-child {
      margin-right: 0;
    }
    .grid-desktop-span8 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 65.88078%;
    }
    .grid-desktop-span8:last-child {
      margin-right: 0;
    }
    .grid-desktop-span9 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 74.41059%;
    }
    .grid-desktop-span9:last-child {
      margin-right: 0;
    }
    .grid-desktop-span10 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 82.94039%;
    }
    .grid-desktop-span10:last-child {
      margin-right: 0;
    }
    .grid-desktop-span11 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 91.4702%;
    }
    .grid-desktop-span11:last-child {
      margin-right: 0;
    }
    .grid-desktop-span12 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 100%;
    }
    .grid-desktop-span12:last-child {
      margin-right: 0;
    }
    .grid-desktop-shift0 {
      margin-left: 0;
    }
    .grid-desktop-shift1 {
      margin-left: 8.5298%;
    }
    .grid-desktop-shift2 {
      margin-left: 17.05961%;
    }
    .grid-desktop-shift3 {
      margin-left: 25.58941%;
    }
    .grid-desktop-shift4 {
      margin-left: 34.11922%;
    }
    .grid-desktop-shift5 {
      margin-left: 42.64902%;
    }
    .grid-desktop-shift6 {
      margin-left: 51.17883%;
    }
    .grid-desktop-shift7 {
      margin-left: 59.70863%;
    }
    .grid-desktop-shift8 {
      margin-left: 68.23843%;
    }
    .grid-desktop-shift9 {
      margin-left: 76.76824%;
    }
    .grid-desktop-shift10 {
      margin-left: 85.29804%;
    }
    .grid-desktop-shift11 {
      margin-left: 93.82785%;
    }
    .grid-desktop-shift-negative1 {
      margin-left: -8.5298%;
    }
    .grid-desktop-shift-negative2 {
      margin-left: -17.05961%;
    }
    .grid-desktop-shift-negative3 {
      margin-left: -25.58941%;
    }
    .grid-desktop-shift-negative4 {
      margin-left: -34.11922%;
    }
    .grid-desktop-shift-negative5 {
      margin-left: -42.64902%;
    }
    .grid-desktop-shift-negative6 {
      margin-left: -51.17883%;
    }
    .grid-desktop-shift-negative7 {
      margin-left: -59.70863%;
    }
    .grid-desktop-shift-negative8 {
      margin-left: -68.23843%;
    }
    .grid-desktop-shift-negative9 {
      margin-left: -76.76824%;
    }
    .grid-desktop-shift-negative10 {
      margin-left: -85.29804%;
    }
    .grid-desktop-shift-negative11 {
      margin-left: -93.82785%;
    }
    .grid-desktop-shift-negative12 {
      margin-left: -102.35765%;
    }
    .grid-desktop-omega {
      margin-right: 0;
    }
    .grid-desktop-omega1:nth-child(1n) {
      margin-right: 0;
    }
    .grid-desktop-omega1:nth-child(1n + 1) {
      clear: left;
    }
    .grid-desktop-omega2:nth-child(2n) {
      margin-right: 0;
    }
    .grid-desktop-omega2:nth-child(2n + 1) {
      clear: left;
    }
    .grid-desktop-omega3:nth-child(3n) {
      margin-right: 0;
    }
    .grid-desktop-omega3:nth-child(3n + 1) {
      clear: left;
    }
    .grid-desktop-omega4:nth-child(4n) {
      margin-right: 0;
    }
    .grid-desktop-omega4:nth-child(4n + 1) {
      clear: left;
    }
    .grid-desktop-omega5:nth-child(5n) {
      margin-right: 0;
    }
    .grid-desktop-omega5:nth-child(5n + 1) {
      clear: left;
    }
    .grid-desktop-omega6:nth-child(6n) {
      margin-right: 0;
    }
    .grid-desktop-omega6:nth-child(6n + 1) {
      clear: left;
    }
    .grid-desktop-omega7:nth-child(7n) {
      margin-right: 0;
    }
    .grid-desktop-omega7:nth-child(7n + 1) {
      clear: left;
    }
    .grid-desktop-omega8:nth-child(8n) {
      margin-right: 0;
    }
    .grid-desktop-omega8:nth-child(8n + 1) {
      clear: left;
    }
    .grid-desktop-omega9:nth-child(9n) {
      margin-right: 0;
    }
    .grid-desktop-omega9:nth-child(9n + 1) {
      clear: left;
    }
    .grid-desktop-omega10:nth-child(10n) {
      margin-right: 0;
    }
    .grid-desktop-omega10:nth-child(10n + 1) {
      clear: left;
    }
    .grid-desktop-omega11:nth-child(11n) {
      margin-right: 0;
    }
    .grid-desktop-omega11:nth-child(11n + 1) {
      clear: left;
    }
    .grid-desktop-omega12:nth-child(12n) {
      margin-right: 0;
    }
    .grid-desktop-omega12:nth-child(12n + 1) {
      clear: left;
    }
    .grid-desktop-gap0-below {
      margin-bottom: 0;
    }
    .grid-desktop-gap1-below {
      margin-bottom: 10px;
    }
    .grid-desktop-gap2-below {
      margin-bottom: 20px;
    }
    .grid-desktop-gap3-below {
      margin-bottom: 30px;
    }
    .grid-desktop-gap4-below {
      margin-bottom: 40px;
    }
    .grid-desktop-gap5-below {
      margin-bottom: 50px;
    }
    .grid-desktop-gap6-below {
      margin-bottom: 60px;
    }
    .grid-desktop-gap7-below {
      margin-bottom: 70px;
    }
    .grid-desktop-gap8-below {
      margin-bottom: 80px;
    }
    .grid-desktop-gap9-below {
      margin-bottom: 90px;
    }
    .grid-desktop-gap10-below {
      margin-bottom: 100px;
    }
    .grid-desktop-gap0-above {
      margin-top: 0;
    }
    .grid-desktop-gap1-above {
      margin-top: 10px;
    }
    .grid-desktop-gap2-above {
      margin-top: 20px;
    }
    .grid-desktop-gap3-above {
      margin-top: 30px;
    }
    .grid-desktop-gap4-above {
      margin-top: 40px;
    }
    .grid-desktop-gap5-above {
      margin-top: 50px;
    }
    .grid-desktop-gap6-above {
      margin-top: 60px;
    }
    .grid-desktop-gap7-above {
      margin-top: 70px;
    }
    .grid-desktop-gap8-above {
      margin-top: 80px;
    }
    .grid-desktop-gap9-above {
      margin-top: 90px;
    }
    .grid-desktop-gap10-above {
      margin-top: 100px;
    }
  }
  @media screen and (max-width: 900px) {
    .grid-laptop-row {
      display: block;
    }
    .grid-laptop-row::after {
      clear: both;
      content: '';
      display: block;
    }
    .grid-laptop-outer-container {
      max-width: 1140px;
      margin-left: auto;
      margin-right: auto;
    }
    .grid-laptop-outer-container::after {
      clear: both;
      content: '';
      display: block;
    }
    .grid-laptop-fill-parent {
      width: 100%;
    }
    .grid-laptop-text-left {
      text-align: left;
    }
    .grid-laptop-text-center {
      text-align: center;
    }
    .grid-laptop-text-right {
      text-align: right;
    }
    .grid-laptop-hidden {
      display: none;
    }
    .grid-laptop-visible {
      display: block;
    }
    .grid-laptop-span1-nogap {
      float: left;
      display: block;
      width: 8.33333%;
      margin-right: 0;
    }
    .grid-laptop-span2-nogap {
      float: left;
      display: block;
      width: 16.66667%;
      margin-right: 0;
    }
    .grid-laptop-span3-nogap {
      float: left;
      display: block;
      width: 25%;
      margin-right: 0;
    }
    .grid-laptop-span4-nogap {
      float: left;
      display: block;
      width: 33.33333%;
      margin-right: 0;
    }
    .grid-laptop-span5-nogap {
      float: left;
      display: block;
      width: 41.66667%;
      margin-right: 0;
    }
    .grid-laptop-span6-nogap {
      float: left;
      display: block;
      width: 50%;
      margin-right: 0;
    }
    .grid-laptop-span7-nogap {
      float: left;
      display: block;
      width: 58.33333%;
      margin-right: 0;
    }
    .grid-laptop-span8-nogap {
      float: left;
      display: block;
      width: 66.66667%;
      margin-right: 0;
    }
    .grid-laptop-span9-nogap {
      float: left;
      display: block;
      width: 75%;
      margin-right: 0;
    }
    .grid-laptop-span10-nogap {
      float: left;
      display: block;
      width: 83.33333%;
      margin-right: 0;
    }
    .grid-laptop-span11-nogap {
      float: left;
      display: block;
      width: 91.66667%;
      margin-right: 0;
    }
    .grid-laptop-span12-nogap {
      float: left;
      display: block;
      width: 100%;
      margin-right: 0;
    }
    .grid-laptop-shift1-nogap {
      margin-left: 8.33333%;
    }
    .grid-laptop-shift2-nogap {
      margin-left: 16.66667%;
    }
    .grid-laptop-shift3-nogap {
      margin-left: 25%;
    }
    .grid-laptop-shift4-nogap {
      margin-left: 33.33333%;
    }
    .grid-laptop-shift5-nogap {
      margin-left: 41.66667%;
    }
    .grid-laptop-shift6-nogap {
      margin-left: 50%;
    }
    .grid-laptop-shift7-nogap {
      margin-left: 58.33333%;
    }
    .grid-laptop-shift8-nogap {
      margin-left: 66.66667%;
    }
    .grid-laptop-shift9-nogap {
      margin-left: 75%;
    }
    .grid-laptop-shift10-nogap {
      margin-left: 83.33333%;
    }
    .grid-laptop-shift11-nogap {
      margin-left: 91.66667%;
    }
    .grid-laptop-shift12-nogap {
      margin-left: 100%;
    }
    .grid-laptop-span1 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 6.17215%;
    }
    .grid-laptop-span1:last-child {
      margin-right: 0;
    }
    .grid-laptop-span2 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 14.70196%;
    }
    .grid-laptop-span2:last-child {
      margin-right: 0;
    }
    .grid-laptop-span3 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 23.23176%;
    }
    .grid-laptop-span3:last-child {
      margin-right: 0;
    }
    .grid-laptop-span4 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 31.76157%;
    }
    .grid-laptop-span4:last-child {
      margin-right: 0;
    }
    .grid-laptop-span5 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 40.29137%;
    }
    .grid-laptop-span5:last-child {
      margin-right: 0;
    }
    .grid-laptop-span6 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 48.82117%;
    }
    .grid-laptop-span6:last-child {
      margin-right: 0;
    }
    .grid-laptop-span7 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 57.35098%;
    }
    .grid-laptop-span7:last-child {
      margin-right: 0;
    }
    .grid-laptop-span8 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 65.88078%;
    }
    .grid-laptop-span8:last-child {
      margin-right: 0;
    }
    .grid-laptop-span9 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 74.41059%;
    }
    .grid-laptop-span9:last-child {
      margin-right: 0;
    }
    .grid-laptop-span10 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 82.94039%;
    }
    .grid-laptop-span10:last-child {
      margin-right: 0;
    }
    .grid-laptop-span11 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 91.4702%;
    }
    .grid-laptop-span11:last-child {
      margin-right: 0;
    }
    .grid-laptop-span12 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 100%;
    }
    .grid-laptop-span12:last-child {
      margin-right: 0;
    }
    .grid-laptop-shift0 {
      margin-left: 0;
    }
    .grid-laptop-shift1 {
      margin-left: 8.5298%;
    }
    .grid-laptop-shift2 {
      margin-left: 17.05961%;
    }
    .grid-laptop-shift3 {
      margin-left: 25.58941%;
    }
    .grid-laptop-shift4 {
      margin-left: 34.11922%;
    }
    .grid-laptop-shift5 {
      margin-left: 42.64902%;
    }
    .grid-laptop-shift6 {
      margin-left: 51.17883%;
    }
    .grid-laptop-shift7 {
      margin-left: 59.70863%;
    }
    .grid-laptop-shift8 {
      margin-left: 68.23843%;
    }
    .grid-laptop-shift9 {
      margin-left: 76.76824%;
    }
    .grid-laptop-shift10 {
      margin-left: 85.29804%;
    }
    .grid-laptop-shift11 {
      margin-left: 93.82785%;
    }
    .grid-laptop-shift-negative1 {
      margin-left: -8.5298%;
    }
    .grid-laptop-shift-negative2 {
      margin-left: -17.05961%;
    }
    .grid-laptop-shift-negative3 {
      margin-left: -25.58941%;
    }
    .grid-laptop-shift-negative4 {
      margin-left: -34.11922%;
    }
    .grid-laptop-shift-negative5 {
      margin-left: -42.64902%;
    }
    .grid-laptop-shift-negative6 {
      margin-left: -51.17883%;
    }
    .grid-laptop-shift-negative7 {
      margin-left: -59.70863%;
    }
    .grid-laptop-shift-negative8 {
      margin-left: -68.23843%;
    }
    .grid-laptop-shift-negative9 {
      margin-left: -76.76824%;
    }
    .grid-laptop-shift-negative10 {
      margin-left: -85.29804%;
    }
    .grid-laptop-shift-negative11 {
      margin-left: -93.82785%;
    }
    .grid-laptop-shift-negative12 {
      margin-left: -102.35765%;
    }
    .grid-laptop-omega {
      margin-right: 0;
    }
    .grid-laptop-omega1:nth-child(1n) {
      margin-right: 0;
    }
    .grid-laptop-omega1:nth-child(1n + 1) {
      clear: left;
    }
    .grid-laptop-omega2:nth-child(2n) {
      margin-right: 0;
    }
    .grid-laptop-omega2:nth-child(2n + 1) {
      clear: left;
    }
    .grid-laptop-omega3:nth-child(3n) {
      margin-right: 0;
    }
    .grid-laptop-omega3:nth-child(3n + 1) {
      clear: left;
    }
    .grid-laptop-omega4:nth-child(4n) {
      margin-right: 0;
    }
    .grid-laptop-omega4:nth-child(4n + 1) {
      clear: left;
    }
    .grid-laptop-omega5:nth-child(5n) {
      margin-right: 0;
    }
    .grid-laptop-omega5:nth-child(5n + 1) {
      clear: left;
    }
    .grid-laptop-omega6:nth-child(6n) {
      margin-right: 0;
    }
    .grid-laptop-omega6:nth-child(6n + 1) {
      clear: left;
    }
    .grid-laptop-omega7:nth-child(7n) {
      margin-right: 0;
    }
    .grid-laptop-omega7:nth-child(7n + 1) {
      clear: left;
    }
    .grid-laptop-omega8:nth-child(8n) {
      margin-right: 0;
    }
    .grid-laptop-omega8:nth-child(8n + 1) {
      clear: left;
    }
    .grid-laptop-omega9:nth-child(9n) {
      margin-right: 0;
    }
    .grid-laptop-omega9:nth-child(9n + 1) {
      clear: left;
    }
    .grid-laptop-omega10:nth-child(10n) {
      margin-right: 0;
    }
    .grid-laptop-omega10:nth-child(10n + 1) {
      clear: left;
    }
    .grid-laptop-omega11:nth-child(11n) {
      margin-right: 0;
    }
    .grid-laptop-omega11:nth-child(11n + 1) {
      clear: left;
    }
    .grid-laptop-omega12:nth-child(12n) {
      margin-right: 0;
    }
    .grid-laptop-omega12:nth-child(12n + 1) {
      clear: left;
    }
    .grid-laptop-gap0-below {
      margin-bottom: 0;
    }
    .grid-laptop-gap1-below {
      margin-bottom: 10px;
    }
    .grid-laptop-gap2-below {
      margin-bottom: 20px;
    }
    .grid-laptop-gap3-below {
      margin-bottom: 30px;
    }
    .grid-laptop-gap4-below {
      margin-bottom: 40px;
    }
    .grid-laptop-gap5-below {
      margin-bottom: 50px;
    }
    .grid-laptop-gap6-below {
      margin-bottom: 60px;
    }
    .grid-laptop-gap7-below {
      margin-bottom: 70px;
    }
    .grid-laptop-gap8-below {
      margin-bottom: 80px;
    }
    .grid-laptop-gap9-below {
      margin-bottom: 90px;
    }
    .grid-laptop-gap10-below {
      margin-bottom: 100px;
    }
    .grid-laptop-gap0-above {
      margin-top: 0;
    }
    .grid-laptop-gap1-above {
      margin-top: 10px;
    }
    .grid-laptop-gap2-above {
      margin-top: 20px;
    }
    .grid-laptop-gap3-above {
      margin-top: 30px;
    }
    .grid-laptop-gap4-above {
      margin-top: 40px;
    }
    .grid-laptop-gap5-above {
      margin-top: 50px;
    }
    .grid-laptop-gap6-above {
      margin-top: 60px;
    }
    .grid-laptop-gap7-above {
      margin-top: 70px;
    }
    .grid-laptop-gap8-above {
      margin-top: 80px;
    }
    .grid-laptop-gap9-above {
      margin-top: 90px;
    }
    .grid-laptop-gap10-above {
      margin-top: 100px;
    }
  }
  @media screen and (max-width: 767px) {
    .grid-tablet-row {
      display: block;
    }
    .grid-tablet-row::after {
      clear: both;
      content: '';
      display: block;
    }
    .grid-tablet-outer-container {
      max-width: 1140px;
      margin-left: auto;
      margin-right: auto;
    }
    .grid-tablet-outer-container::after {
      clear: both;
      content: '';
      display: block;
    }
    .grid-tablet-fill-parent {
      width: 100%;
    }
    .grid-tablet-text-left {
      text-align: left;
    }
    .grid-tablet-text-center {
      text-align: center;
    }
    .grid-tablet-text-right {
      text-align: right;
    }
    .grid-tablet-hidden {
      display: none;
    }
    .grid-tablet-visible {
      display: block;
    }
    .grid-tablet-span1-nogap {
      float: left;
      display: block;
      width: 8.33333%;
      margin-right: 0;
    }
    .grid-tablet-span2-nogap {
      float: left;
      display: block;
      width: 16.66667%;
      margin-right: 0;
    }
    .grid-tablet-span3-nogap {
      float: left;
      display: block;
      width: 25%;
      margin-right: 0;
    }
    .grid-tablet-span4-nogap {
      float: left;
      display: block;
      width: 33.33333%;
      margin-right: 0;
    }
    .grid-tablet-span5-nogap {
      float: left;
      display: block;
      width: 41.66667%;
      margin-right: 0;
    }
    .grid-tablet-span6-nogap {
      float: left;
      display: block;
      width: 50%;
      margin-right: 0;
    }
    .grid-tablet-span7-nogap {
      float: left;
      display: block;
      width: 58.33333%;
      margin-right: 0;
    }
    .grid-tablet-span8-nogap {
      float: left;
      display: block;
      width: 66.66667%;
      margin-right: 0;
    }
    .grid-tablet-span9-nogap {
      float: left;
      display: block;
      width: 75%;
      margin-right: 0;
    }
    .grid-tablet-span10-nogap {
      float: left;
      display: block;
      width: 83.33333%;
      margin-right: 0;
    }
    .grid-tablet-span11-nogap {
      float: left;
      display: block;
      width: 91.66667%;
      margin-right: 0;
    }
    .grid-tablet-span12-nogap {
      float: left;
      display: block;
      width: 100%;
      margin-right: 0;
    }
    .grid-tablet-shift1-nogap {
      margin-left: 8.33333%;
    }
    .grid-tablet-shift2-nogap {
      margin-left: 16.66667%;
    }
    .grid-tablet-shift3-nogap {
      margin-left: 25%;
    }
    .grid-tablet-shift4-nogap {
      margin-left: 33.33333%;
    }
    .grid-tablet-shift5-nogap {
      margin-left: 41.66667%;
    }
    .grid-tablet-shift6-nogap {
      margin-left: 50%;
    }
    .grid-tablet-shift7-nogap {
      margin-left: 58.33333%;
    }
    .grid-tablet-shift8-nogap {
      margin-left: 66.66667%;
    }
    .grid-tablet-shift9-nogap {
      margin-left: 75%;
    }
    .grid-tablet-shift10-nogap {
      margin-left: 83.33333%;
    }
    .grid-tablet-shift11-nogap {
      margin-left: 91.66667%;
    }
    .grid-tablet-shift12-nogap {
      margin-left: 100%;
    }
    .grid-tablet-span1 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 6.17215%;
    }
    .grid-tablet-span1:last-child {
      margin-right: 0;
    }
    .grid-tablet-span2 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 14.70196%;
    }
    .grid-tablet-span2:last-child {
      margin-right: 0;
    }
    .grid-tablet-span3 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 23.23176%;
    }
    .grid-tablet-span3:last-child {
      margin-right: 0;
    }
    .grid-tablet-span4 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 31.76157%;
    }
    .grid-tablet-span4:last-child {
      margin-right: 0;
    }
    .grid-tablet-span5 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 40.29137%;
    }
    .grid-tablet-span5:last-child {
      margin-right: 0;
    }
    .grid-tablet-span6 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 48.82117%;
    }
    .grid-tablet-span6:last-child {
      margin-right: 0;
    }
    .grid-tablet-span7 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 57.35098%;
    }
    .grid-tablet-span7:last-child {
      margin-right: 0;
    }
    .grid-tablet-span8 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 65.88078%;
    }
    .grid-tablet-span8:last-child {
      margin-right: 0;
    }
    .grid-tablet-span9 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 74.41059%;
    }
    .grid-tablet-span9:last-child {
      margin-right: 0;
    }
    .grid-tablet-span10 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 82.94039%;
    }
    .grid-tablet-span10:last-child {
      margin-right: 0;
    }
    .grid-tablet-span11 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 91.4702%;
    }
    .grid-tablet-span11:last-child {
      margin-right: 0;
    }
    .grid-tablet-span12 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 100%;
    }
    .grid-tablet-span12:last-child {
      margin-right: 0;
    }
    .grid-tablet-shift0 {
      margin-left: 0;
    }
    .grid-tablet-shift1 {
      margin-left: 8.5298%;
    }
    .grid-tablet-shift2 {
      margin-left: 17.05961%;
    }
    .grid-tablet-shift3 {
      margin-left: 25.58941%;
    }
    .grid-tablet-shift4 {
      margin-left: 34.11922%;
    }
    .grid-tablet-shift5 {
      margin-left: 42.64902%;
    }
    .grid-tablet-shift6 {
      margin-left: 51.17883%;
    }
    .grid-tablet-shift7 {
      margin-left: 59.70863%;
    }
    .grid-tablet-shift8 {
      margin-left: 68.23843%;
    }
    .grid-tablet-shift9 {
      margin-left: 76.76824%;
    }
    .grid-tablet-shift10 {
      margin-left: 85.29804%;
    }
    .grid-tablet-shift11 {
      margin-left: 93.82785%;
    }
    .grid-tablet-shift-negative1 {
      margin-left: -8.5298%;
    }
    .grid-tablet-shift-negative2 {
      margin-left: -17.05961%;
    }
    .grid-tablet-shift-negative3 {
      margin-left: -25.58941%;
    }
    .grid-tablet-shift-negative4 {
      margin-left: -34.11922%;
    }
    .grid-tablet-shift-negative5 {
      margin-left: -42.64902%;
    }
    .grid-tablet-shift-negative6 {
      margin-left: -51.17883%;
    }
    .grid-tablet-shift-negative7 {
      margin-left: -59.70863%;
    }
    .grid-tablet-shift-negative8 {
      margin-left: -68.23843%;
    }
    .grid-tablet-shift-negative9 {
      margin-left: -76.76824%;
    }
    .grid-tablet-shift-negative10 {
      margin-left: -85.29804%;
    }
    .grid-tablet-shift-negative11 {
      margin-left: -93.82785%;
    }
    .grid-tablet-shift-negative12 {
      margin-left: -102.35765%;
    }
    .grid-tablet-omega {
      margin-right: 0;
    }
    .grid-tablet-omega1:nth-child(1n) {
      margin-right: 0;
    }
    .grid-tablet-omega1:nth-child(1n + 1) {
      clear: left;
    }
    .grid-tablet-omega2:nth-child(2n) {
      margin-right: 0;
    }
    .grid-tablet-omega2:nth-child(2n + 1) {
      clear: left;
    }
    .grid-tablet-omega3:nth-child(3n) {
      margin-right: 0;
    }
    .grid-tablet-omega3:nth-child(3n + 1) {
      clear: left;
    }
    .grid-tablet-omega4:nth-child(4n) {
      margin-right: 0;
    }
    .grid-tablet-omega4:nth-child(4n + 1) {
      clear: left;
    }
    .grid-tablet-omega5:nth-child(5n) {
      margin-right: 0;
    }
    .grid-tablet-omega5:nth-child(5n + 1) {
      clear: left;
    }
    .grid-tablet-omega6:nth-child(6n) {
      margin-right: 0;
    }
    .grid-tablet-omega6:nth-child(6n + 1) {
      clear: left;
    }
    .grid-tablet-omega7:nth-child(7n) {
      margin-right: 0;
    }
    .grid-tablet-omega7:nth-child(7n + 1) {
      clear: left;
    }
    .grid-tablet-omega8:nth-child(8n) {
      margin-right: 0;
    }
    .grid-tablet-omega8:nth-child(8n + 1) {
      clear: left;
    }
    .grid-tablet-omega9:nth-child(9n) {
      margin-right: 0;
    }
    .grid-tablet-omega9:nth-child(9n + 1) {
      clear: left;
    }
    .grid-tablet-omega10:nth-child(10n) {
      margin-right: 0;
    }
    .grid-tablet-omega10:nth-child(10n + 1) {
      clear: left;
    }
    .grid-tablet-omega11:nth-child(11n) {
      margin-right: 0;
    }
    .grid-tablet-omega11:nth-child(11n + 1) {
      clear: left;
    }
    .grid-tablet-omega12:nth-child(12n) {
      margin-right: 0;
    }
    .grid-tablet-omega12:nth-child(12n + 1) {
      clear: left;
    }
    .grid-tablet-gap0-below {
      margin-bottom: 0;
    }
    .grid-tablet-gap1-below {
      margin-bottom: 10px;
    }
    .grid-tablet-gap2-below {
      margin-bottom: 20px;
    }
    .grid-tablet-gap3-below {
      margin-bottom: 30px;
    }
    .grid-tablet-gap4-below {
      margin-bottom: 40px;
    }
    .grid-tablet-gap5-below {
      margin-bottom: 50px;
    }
    .grid-tablet-gap6-below {
      margin-bottom: 60px;
    }
    .grid-tablet-gap7-below {
      margin-bottom: 70px;
    }
    .grid-tablet-gap8-below {
      margin-bottom: 80px;
    }
    .grid-tablet-gap9-below {
      margin-bottom: 90px;
    }
    .grid-tablet-gap10-below {
      margin-bottom: 100px;
    }
    .grid-tablet-gap0-above {
      margin-top: 0;
    }
    .grid-tablet-gap1-above {
      margin-top: 10px;
    }
    .grid-tablet-gap2-above {
      margin-top: 20px;
    }
    .grid-tablet-gap3-above {
      margin-top: 30px;
    }
    .grid-tablet-gap4-above {
      margin-top: 40px;
    }
    .grid-tablet-gap5-above {
      margin-top: 50px;
    }
    .grid-tablet-gap6-above {
      margin-top: 60px;
    }
    .grid-tablet-gap7-above {
      margin-top: 70px;
    }
    .grid-tablet-gap8-above {
      margin-top: 80px;
    }
    .grid-tablet-gap9-above {
      margin-top: 90px;
    }
    .grid-tablet-gap10-above {
      margin-top: 100px;
    }
  }
  @media screen and (min-width: 768px) {
    .grid-abovetablet-row {
      display: block;
    }
    .grid-abovetablet-row::after {
      clear: both;
      content: '';
      display: block;
    }
    .grid-abovetablet-outer-container {
      max-width: 1140px;
      margin-left: auto;
      margin-right: auto;
    }
    .grid-abovetablet-outer-container::after {
      clear: both;
      content: '';
      display: block;
    }
    .grid-abovetablet-fill-parent {
      width: 100%;
    }
    .grid-abovetablet-text-left {
      text-align: left;
    }
    .grid-abovetablet-text-center {
      text-align: center;
    }
    .grid-abovetablet-text-right {
      text-align: right;
    }
    .grid-abovetablet-hidden {
      display: none;
    }
    .grid-abovetablet-visible {
      display: block;
    }
    .grid-abovetablet-span1-nogap {
      float: left;
      display: block;
      width: 8.33333%;
      margin-right: 0;
    }
    .grid-abovetablet-span2-nogap {
      float: left;
      display: block;
      width: 16.66667%;
      margin-right: 0;
    }
    .grid-abovetablet-span3-nogap {
      float: left;
      display: block;
      width: 25%;
      margin-right: 0;
    }
    .grid-abovetablet-span4-nogap {
      float: left;
      display: block;
      width: 33.33333%;
      margin-right: 0;
    }
    .grid-abovetablet-span5-nogap {
      float: left;
      display: block;
      width: 41.66667%;
      margin-right: 0;
    }
    .grid-abovetablet-span6-nogap {
      float: left;
      display: block;
      width: 50%;
      margin-right: 0;
    }
    .grid-abovetablet-span7-nogap {
      float: left;
      display: block;
      width: 58.33333%;
      margin-right: 0;
    }
    .grid-abovetablet-span8-nogap {
      float: left;
      display: block;
      width: 66.66667%;
      margin-right: 0;
    }
    .grid-abovetablet-span9-nogap {
      float: left;
      display: block;
      width: 75%;
      margin-right: 0;
    }
    .grid-abovetablet-span10-nogap {
      float: left;
      display: block;
      width: 83.33333%;
      margin-right: 0;
    }
    .grid-abovetablet-span11-nogap {
      float: left;
      display: block;
      width: 91.66667%;
      margin-right: 0;
    }
    .grid-abovetablet-span12-nogap {
      float: left;
      display: block;
      width: 100%;
      margin-right: 0;
    }
    .grid-abovetablet-shift1-nogap {
      margin-left: 8.33333%;
    }
    .grid-abovetablet-shift2-nogap {
      margin-left: 16.66667%;
    }
    .grid-abovetablet-shift3-nogap {
      margin-left: 25%;
    }
    .grid-abovetablet-shift4-nogap {
      margin-left: 33.33333%;
    }
    .grid-abovetablet-shift5-nogap {
      margin-left: 41.66667%;
    }
    .grid-abovetablet-shift6-nogap {
      margin-left: 50%;
    }
    .grid-abovetablet-shift7-nogap {
      margin-left: 58.33333%;
    }
    .grid-abovetablet-shift8-nogap {
      margin-left: 66.66667%;
    }
    .grid-abovetablet-shift9-nogap {
      margin-left: 75%;
    }
    .grid-abovetablet-shift10-nogap {
      margin-left: 83.33333%;
    }
    .grid-abovetablet-shift11-nogap {
      margin-left: 91.66667%;
    }
    .grid-abovetablet-shift12-nogap {
      margin-left: 100%;
    }
    .grid-abovetablet-span1 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 6.17215%;
    }
    .grid-abovetablet-span1:last-child {
      margin-right: 0;
    }
    .grid-abovetablet-span2 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 14.70196%;
    }
    .grid-abovetablet-span2:last-child {
      margin-right: 0;
    }
    .grid-abovetablet-span3 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 23.23176%;
    }
    .grid-abovetablet-span3:last-child {
      margin-right: 0;
    }
    .grid-abovetablet-span4 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 31.76157%;
    }
    .grid-abovetablet-span4:last-child {
      margin-right: 0;
    }
    .grid-abovetablet-span5 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 40.29137%;
    }
    .grid-abovetablet-span5:last-child {
      margin-right: 0;
    }
    .grid-abovetablet-span6 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 48.82117%;
    }
    .grid-abovetablet-span6:last-child {
      margin-right: 0;
    }
    .grid-abovetablet-span7 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 57.35098%;
    }
    .grid-abovetablet-span7:last-child {
      margin-right: 0;
    }
    .grid-abovetablet-span8 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 65.88078%;
    }
    .grid-abovetablet-span8:last-child {
      margin-right: 0;
    }
    .grid-abovetablet-span9 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 74.41059%;
    }
    .grid-abovetablet-span9:last-child {
      margin-right: 0;
    }
    .grid-abovetablet-span10 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 82.94039%;
    }
    .grid-abovetablet-span10:last-child {
      margin-right: 0;
    }
    .grid-abovetablet-span11 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 91.4702%;
    }
    .grid-abovetablet-span11:last-child {
      margin-right: 0;
    }
    .grid-abovetablet-span12 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 100%;
    }
    .grid-abovetablet-span12:last-child {
      margin-right: 0;
    }
    .grid-abovetablet-shift0 {
      margin-left: 0;
    }
    .grid-abovetablet-shift1 {
      margin-left: 8.5298%;
    }
    .grid-abovetablet-shift2 {
      margin-left: 17.05961%;
    }
    .grid-abovetablet-shift3 {
      margin-left: 25.58941%;
    }
    .grid-abovetablet-shift4 {
      margin-left: 34.11922%;
    }
    .grid-abovetablet-shift5 {
      margin-left: 42.64902%;
    }
    .grid-abovetablet-shift6 {
      margin-left: 51.17883%;
    }
    .grid-abovetablet-shift7 {
      margin-left: 59.70863%;
    }
    .grid-abovetablet-shift8 {
      margin-left: 68.23843%;
    }
    .grid-abovetablet-shift9 {
      margin-left: 76.76824%;
    }
    .grid-abovetablet-shift10 {
      margin-left: 85.29804%;
    }
    .grid-abovetablet-shift11 {
      margin-left: 93.82785%;
    }
    .grid-abovetablet-shift-negative1 {
      margin-left: -8.5298%;
    }
    .grid-abovetablet-shift-negative2 {
      margin-left: -17.05961%;
    }
    .grid-abovetablet-shift-negative3 {
      margin-left: -25.58941%;
    }
    .grid-abovetablet-shift-negative4 {
      margin-left: -34.11922%;
    }
    .grid-abovetablet-shift-negative5 {
      margin-left: -42.64902%;
    }
    .grid-abovetablet-shift-negative6 {
      margin-left: -51.17883%;
    }
    .grid-abovetablet-shift-negative7 {
      margin-left: -59.70863%;
    }
    .grid-abovetablet-shift-negative8 {
      margin-left: -68.23843%;
    }
    .grid-abovetablet-shift-negative9 {
      margin-left: -76.76824%;
    }
    .grid-abovetablet-shift-negative10 {
      margin-left: -85.29804%;
    }
    .grid-abovetablet-shift-negative11 {
      margin-left: -93.82785%;
    }
    .grid-abovetablet-shift-negative12 {
      margin-left: -102.35765%;
    }
    .grid-abovetablet-omega {
      margin-right: 0;
    }
    .grid-abovetablet-omega1:nth-child(1n) {
      margin-right: 0;
    }
    .grid-abovetablet-omega1:nth-child(1n + 1) {
      clear: left;
    }
    .grid-abovetablet-omega2:nth-child(2n) {
      margin-right: 0;
    }
    .grid-abovetablet-omega2:nth-child(2n + 1) {
      clear: left;
    }
    .grid-abovetablet-omega3:nth-child(3n) {
      margin-right: 0;
    }
    .grid-abovetablet-omega3:nth-child(3n + 1) {
      clear: left;
    }
    .grid-abovetablet-omega4:nth-child(4n) {
      margin-right: 0;
    }
    .grid-abovetablet-omega4:nth-child(4n + 1) {
      clear: left;
    }
    .grid-abovetablet-omega5:nth-child(5n) {
      margin-right: 0;
    }
    .grid-abovetablet-omega5:nth-child(5n + 1) {
      clear: left;
    }
    .grid-abovetablet-omega6:nth-child(6n) {
      margin-right: 0;
    }
    .grid-abovetablet-omega6:nth-child(6n + 1) {
      clear: left;
    }
    .grid-abovetablet-omega7:nth-child(7n) {
      margin-right: 0;
    }
    .grid-abovetablet-omega7:nth-child(7n + 1) {
      clear: left;
    }
    .grid-abovetablet-omega8:nth-child(8n) {
      margin-right: 0;
    }
    .grid-abovetablet-omega8:nth-child(8n + 1) {
      clear: left;
    }
    .grid-abovetablet-omega9:nth-child(9n) {
      margin-right: 0;
    }
    .grid-abovetablet-omega9:nth-child(9n + 1) {
      clear: left;
    }
    .grid-abovetablet-omega10:nth-child(10n) {
      margin-right: 0;
    }
    .grid-abovetablet-omega10:nth-child(10n + 1) {
      clear: left;
    }
    .grid-abovetablet-omega11:nth-child(11n) {
      margin-right: 0;
    }
    .grid-abovetablet-omega11:nth-child(11n + 1) {
      clear: left;
    }
    .grid-abovetablet-omega12:nth-child(12n) {
      margin-right: 0;
    }
    .grid-abovetablet-omega12:nth-child(12n + 1) {
      clear: left;
    }
    .grid-abovetablet-gap0-below {
      margin-bottom: 0;
    }
    .grid-abovetablet-gap1-below {
      margin-bottom: 10px;
    }
    .grid-abovetablet-gap2-below {
      margin-bottom: 20px;
    }
    .grid-abovetablet-gap3-below {
      margin-bottom: 30px;
    }
    .grid-abovetablet-gap4-below {
      margin-bottom: 40px;
    }
    .grid-abovetablet-gap5-below {
      margin-bottom: 50px;
    }
    .grid-abovetablet-gap6-below {
      margin-bottom: 60px;
    }
    .grid-abovetablet-gap7-below {
      margin-bottom: 70px;
    }
    .grid-abovetablet-gap8-below {
      margin-bottom: 80px;
    }
    .grid-abovetablet-gap9-below {
      margin-bottom: 90px;
    }
    .grid-abovetablet-gap10-below {
      margin-bottom: 100px;
    }
    .grid-abovetablet-gap0-above {
      margin-top: 0;
    }
    .grid-abovetablet-gap1-above {
      margin-top: 10px;
    }
    .grid-abovetablet-gap2-above {
      margin-top: 20px;
    }
    .grid-abovetablet-gap3-above {
      margin-top: 30px;
    }
    .grid-abovetablet-gap4-above {
      margin-top: 40px;
    }
    .grid-abovetablet-gap5-above {
      margin-top: 50px;
    }
    .grid-abovetablet-gap6-above {
      margin-top: 60px;
    }
    .grid-abovetablet-gap7-above {
      margin-top: 70px;
    }
    .grid-abovetablet-gap8-above {
      margin-top: 80px;
    }
    .grid-abovetablet-gap9-above {
      margin-top: 90px;
    }
    .grid-abovetablet-gap10-above {
      margin-top: 100px;
    }
  }
  @media screen and (max-width: 480px) {
    .grid-mobile-row {
      display: block;
    }
    .grid-mobile-row::after {
      clear: both;
      content: '';
      display: block;
    }
    .grid-mobile-outer-container {
      max-width: 1140px;
      margin-left: auto;
      margin-right: auto;
    }
    .grid-mobile-outer-container::after {
      clear: both;
      content: '';
      display: block;
    }
    .grid-mobile-fill-parent {
      width: 100%;
    }
    .grid-mobile-text-left {
      text-align: left;
    }
    .grid-mobile-text-center {
      text-align: center;
    }
    .grid-mobile-text-right {
      text-align: right;
    }
    .grid-mobile-hidden {
      display: none;
    }
    .grid-mobile-visible {
      display: block;
    }
    .grid-mobile-span1-nogap {
      float: left;
      display: block;
      width: 8.33333%;
      margin-right: 0;
    }
    .grid-mobile-span2-nogap {
      float: left;
      display: block;
      width: 16.66667%;
      margin-right: 0;
    }
    .grid-mobile-span3-nogap {
      float: left;
      display: block;
      width: 25%;
      margin-right: 0;
    }
    .grid-mobile-span4-nogap {
      float: left;
      display: block;
      width: 33.33333%;
      margin-right: 0;
    }
    .grid-mobile-span5-nogap {
      float: left;
      display: block;
      width: 41.66667%;
      margin-right: 0;
    }
    .grid-mobile-span6-nogap {
      float: left;
      display: block;
      width: 50%;
      margin-right: 0;
    }
    .grid-mobile-span7-nogap {
      float: left;
      display: block;
      width: 58.33333%;
      margin-right: 0;
    }
    .grid-mobile-span8-nogap {
      float: left;
      display: block;
      width: 66.66667%;
      margin-right: 0;
    }
    .grid-mobile-span9-nogap {
      float: left;
      display: block;
      width: 75%;
      margin-right: 0;
    }
    .grid-mobile-span10-nogap {
      float: left;
      display: block;
      width: 83.33333%;
      margin-right: 0;
    }
    .grid-mobile-span11-nogap {
      float: left;
      display: block;
      width: 91.66667%;
      margin-right: 0;
    }
    .grid-mobile-span12-nogap {
      float: left;
      display: block;
      width: 100%;
      margin-right: 0;
    }
    .grid-mobile-shift1-nogap {
      margin-left: 8.33333%;
    }
    .grid-mobile-shift2-nogap {
      margin-left: 16.66667%;
    }
    .grid-mobile-shift3-nogap {
      margin-left: 25%;
    }
    .grid-mobile-shift4-nogap {
      margin-left: 33.33333%;
    }
    .grid-mobile-shift5-nogap {
      margin-left: 41.66667%;
    }
    .grid-mobile-shift6-nogap {
      margin-left: 50%;
    }
    .grid-mobile-shift7-nogap {
      margin-left: 58.33333%;
    }
    .grid-mobile-shift8-nogap {
      margin-left: 66.66667%;
    }
    .grid-mobile-shift9-nogap {
      margin-left: 75%;
    }
    .grid-mobile-shift10-nogap {
      margin-left: 83.33333%;
    }
    .grid-mobile-shift11-nogap {
      margin-left: 91.66667%;
    }
    .grid-mobile-shift12-nogap {
      margin-left: 100%;
    }
    .grid-mobile-span1 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 6.17215%;
    }
    .grid-mobile-span1:last-child {
      margin-right: 0;
    }
    .grid-mobile-span2 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 14.70196%;
    }
    .grid-mobile-span2:last-child {
      margin-right: 0;
    }
    .grid-mobile-span3 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 23.23176%;
    }
    .grid-mobile-span3:last-child {
      margin-right: 0;
    }
    .grid-mobile-span4 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 31.76157%;
    }
    .grid-mobile-span4:last-child {
      margin-right: 0;
    }
    .grid-mobile-span5 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 40.29137%;
    }
    .grid-mobile-span5:last-child {
      margin-right: 0;
    }
    .grid-mobile-span6 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 48.82117%;
    }
    .grid-mobile-span6:last-child {
      margin-right: 0;
    }
    .grid-mobile-span7 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 57.35098%;
    }
    .grid-mobile-span7:last-child {
      margin-right: 0;
    }
    .grid-mobile-span8 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 65.88078%;
    }
    .grid-mobile-span8:last-child {
      margin-right: 0;
    }
    .grid-mobile-span9 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 74.41059%;
    }
    .grid-mobile-span9:last-child {
      margin-right: 0;
    }
    .grid-mobile-span10 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 82.94039%;
    }
    .grid-mobile-span10:last-child {
      margin-right: 0;
    }
    .grid-mobile-span11 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 91.4702%;
    }
    .grid-mobile-span11:last-child {
      margin-right: 0;
    }
    .grid-mobile-span12 {
      float: left;
      display: block;
      margin-right: 2.35765%;
      width: 100%;
    }
    .grid-mobile-span12:last-child {
      margin-right: 0;
    }
    .grid-mobile-shift0 {
      margin-left: 0;
    }
    .grid-mobile-shift1 {
      margin-left: 8.5298%;
    }
    .grid-mobile-shift2 {
      margin-left: 17.05961%;
    }
    .grid-mobile-shift3 {
      margin-left: 25.58941%;
    }
    .grid-mobile-shift4 {
      margin-left: 34.11922%;
    }
    .grid-mobile-shift5 {
      margin-left: 42.64902%;
    }
    .grid-mobile-shift6 {
      margin-left: 51.17883%;
    }
    .grid-mobile-shift7 {
      margin-left: 59.70863%;
    }
    .grid-mobile-shift8 {
      margin-left: 68.23843%;
    }
    .grid-mobile-shift9 {
      margin-left: 76.76824%;
    }
    .grid-mobile-shift10 {
      margin-left: 85.29804%;
    }
    .grid-mobile-shift11 {
      margin-left: 93.82785%;
    }
    .grid-mobile-shift-negative1 {
      margin-left: -8.5298%;
    }
    .grid-mobile-shift-negative2 {
      margin-left: -17.05961%;
    }
    .grid-mobile-shift-negative3 {
      margin-left: -25.58941%;
    }
    .grid-mobile-shift-negative4 {
      margin-left: -34.11922%;
    }
    .grid-mobile-shift-negative5 {
      margin-left: -42.64902%;
    }
    .grid-mobile-shift-negative6 {
      margin-left: -51.17883%;
    }
    .grid-mobile-shift-negative7 {
      margin-left: -59.70863%;
    }
    .grid-mobile-shift-negative8 {
      margin-left: -68.23843%;
    }
    .grid-mobile-shift-negative9 {
      margin-left: -76.76824%;
    }
    .grid-mobile-shift-negative10 {
      margin-left: -85.29804%;
    }
    .grid-mobile-shift-negative11 {
      margin-left: -93.82785%;
    }
    .grid-mobile-shift-negative12 {
      margin-left: -102.35765%;
    }
    .grid-mobile-omega {
      margin-right: 0;
    }
    .grid-mobile-omega1:nth-child(1n) {
      margin-right: 0;
    }
    .grid-mobile-omega1:nth-child(1n + 1) {
      clear: left;
    }
    .grid-mobile-omega2:nth-child(2n) {
      margin-right: 0;
    }
    .grid-mobile-omega2:nth-child(2n + 1) {
      clear: left;
    }
    .grid-mobile-omega3:nth-child(3n) {
      margin-right: 0;
    }
    .grid-mobile-omega3:nth-child(3n + 1) {
      clear: left;
    }
    .grid-mobile-omega4:nth-child(4n) {
      margin-right: 0;
    }
    .grid-mobile-omega4:nth-child(4n + 1) {
      clear: left;
    }
    .grid-mobile-omega5:nth-child(5n) {
      margin-right: 0;
    }
    .grid-mobile-omega5:nth-child(5n + 1) {
      clear: left;
    }
    .grid-mobile-omega6:nth-child(6n) {
      margin-right: 0;
    }
    .grid-mobile-omega6:nth-child(6n + 1) {
      clear: left;
    }
    .grid-mobile-omega7:nth-child(7n) {
      margin-right: 0;
    }
    .grid-mobile-omega7:nth-child(7n + 1) {
      clear: left;
    }
    .grid-mobile-omega8:nth-child(8n) {
      margin-right: 0;
    }
    .grid-mobile-omega8:nth-child(8n + 1) {
      clear: left;
    }
    .grid-mobile-omega9:nth-child(9n) {
      margin-right: 0;
    }
    .grid-mobile-omega9:nth-child(9n + 1) {
      clear: left;
    }
    .grid-mobile-omega10:nth-child(10n) {
      margin-right: 0;
    }
    .grid-mobile-omega10:nth-child(10n + 1) {
      clear: left;
    }
    .grid-mobile-omega11:nth-child(11n) {
      margin-right: 0;
    }
    .grid-mobile-omega11:nth-child(11n + 1) {
      clear: left;
    }
    .grid-mobile-omega12:nth-child(12n) {
      margin-right: 0;
    }
    .grid-mobile-omega12:nth-child(12n + 1) {
      clear: left;
    }
    .grid-mobile-gap0-below {
      margin-bottom: 0;
    }
    .grid-mobile-gap1-below {
      margin-bottom: 10px;
    }
    .grid-mobile-gap2-below {
      margin-bottom: 20px;
    }
    .grid-mobile-gap3-below {
      margin-bottom: 30px;
    }
    .grid-mobile-gap4-below {
      margin-bottom: 40px;
    }
    .grid-mobile-gap5-below {
      margin-bottom: 50px;
    }
    .grid-mobile-gap6-below {
      margin-bottom: 60px;
    }
    .grid-mobile-gap7-below {
      margin-bottom: 70px;
    }
    .grid-mobile-gap8-below {
      margin-bottom: 80px;
    }
    .grid-mobile-gap9-below {
      margin-bottom: 90px;
    }
    .grid-mobile-gap10-below {
      margin-bottom: 100px;
    }
    .grid-mobile-gap0-above {
      margin-top: 0;
    }
    .grid-mobile-gap1-above {
      margin-top: 10px;
    }
    .grid-mobile-gap2-above {
      margin-top: 20px;
    }
    .grid-mobile-gap3-above {
      margin-top: 30px;
    }
    .grid-mobile-gap4-above {
      margin-top: 40px;
    }
    .grid-mobile-gap5-above {
      margin-top: 50px;
    }
    .grid-mobile-gap6-above {
      margin-top: 60px;
    }
    .grid-mobile-gap7-above {
      margin-top: 70px;
    }
    .grid-mobile-gap8-above {
      margin-top: 80px;
    }
    .grid-mobile-gap9-above {
      margin-top: 90px;
    }
    .grid-mobile-gap10-above {
      margin-top: 100px;
    }
  }
  @media screen and (max-width: 1180px) {
    .grid-outer-container {
      max-width: calc(100% - 40px);
      margin-left: auto;
      margin-right: auto;
    }
    .grid-outer-container::after {
      clear: both;
      content: '';
      display: block;
    }
  }
  @media screen and (max-width: 767px) {
    .grid-outer-container {
      max-width: calc(100% - (10px * 2));
      margin-left: auto;
      margin-right: auto;
    }
    .grid-outer-container::after {
      clear: both;
      content: '';
      display: block;
    }
  }
`
